import React, { FC } from 'react'
import styles from './paymentFailedBanner.module.scss'

interface PaymentFailedBannerProps {
  onPayNow?: () => void
  onUpdateCard?: () => void
}

export const PaymentFailedBanner: FC<PaymentFailedBannerProps> = ({
  onPayNow,
  onUpdateCard,
}) => {
  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <svg
            fill="none"
            height="20"
            viewBox="0 0 20 20"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" fill="#DC2626" r="10" />
            <path
              d="M10 6V10"
              stroke="white"
              strokeLinecap="round"
              strokeWidth="2"
            />
            <circle cx="10" cy="13.5" fill="white" r="1" />
          </svg>
        </div>
        <div className={styles.textContent}>
          <div className={styles.title}>Payment Failed</div>
          <div className={styles.message}>
            We couldn&apos;t process your recent renewal. Please complete the
            payment manually to keep your plan active.
          </div>
        </div>
      </div>
      <div className={styles.actions}>
        <button
          className={styles.payNowButton}
          onClick={onPayNow}
          type="button"
        >
          Pay Now
        </button>
        <button
          className={styles.updateCardButton}
          onClick={onUpdateCard}
          type="button"
        >
          Update Card
        </button>
      </div>
    </div>
  )
}
